import React from "react";
import OffCanvas from "../UI/OffCanvas";
import LoginRegContent from "./LoginRegContent";

const LoginRegister = () => {
  return (
    <OffCanvas type="cog">
      <LoginRegContent />
    </OffCanvas>
  );
};

export default LoginRegister;
